// Navbar, Sidebar & Auth
import { Outlet }         from 'react-router-dom';
import { DesktopSidebar } from 'components/DesktopSidebar/DesktopSidebar';
import { DesktopNavbar }  from 'components/DesktopNavbar/DesktopNavbar';
import { MobileNavbar }   from 'components/MobileNavbar/MobileNavbar';

function WithNavigation(props) {
  return (
    <div>
      <DesktopSidebar />
      <DesktopNavbar dropdownDisplayed={ props.dropdownDisplayed } />
      <MobileNavbar />
      <Outlet/>
    </div>
  );
}

export default WithNavigation;